import React from 'react'
import styles from './styles.css'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import gql from 'graphql-tag'
import Button from 'orionsoft-parts/lib/components/Button'
import {Form, Field} from 'simple-react-form'
import Text from 'orionsoft-parts/lib/components/fields/Text'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import autobind from 'autobind-decorator'
import PropTypes from 'prop-types'
import numeral from 'numeral'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'

@withGraphQL(gql`
  query profile {
    profile {
        name
        lastName
        phone
        rut
    }
  }
`)
@withMutation(gql`
  mutation setUserProfile($profile: UserProfileInput) {
    setUserProfile(profile: $profile) {
      success
    }
  }
`)

@withMutation(gql`
  mutation getDiroLink {
    getDiroLink 
  }
`)

@withMessage
export default class Profile extends React.Component {
  static propTypes = {
    setUserProfile: PropTypes.func,
    getDiroLink: PropTypes.func,
    setError: PropTypes.func,
    showMessage: PropTypes.func,
    profile: PropTypes.object,
  }

  state = {
    valid: true,
    diroCreated: false
  }

  

  @autobind
  async validateAndSend() {  
    const docId = localStorage.getItem('docId')
    const active = localStorage.getItem('active')
    if( !this.state.valid ){
      return alert("Rut invalido");
    }
    console.log("------->validateAndSend")

    try {
      this.setState({loading: true})
      let profileData = {}
      if(this.state.name)
      profileData.name = this.state.name
      if(this.state.lastName)
      profileData.lastName = this.state.lastName
      if(this.state.phone)
      profileData.phone = this.state.phone
      if(this.state.rut)
      profileData.rut = this.state.rut
      
      await this.props.setUserProfile(
        {
          profile: profileData
        },
        {
          refetchQueries: ['profile']
        })
        this.props.showMessage('Tu perfil fue actualizado')
        this.setState({loading: false, editando:false})
        if((docId && active) !== undefined){
          console.log('Pasando a comeBackDoc')
          setTimeout(this.comeBackDoc(this.state.loading,this.state.editando),4000)
          localStorage.removeItem('docLink')
          localStorage.removeItem('docId')
          localStorage.removeItem('active')
        }
    } catch (error) {
      this.setState({loading: false})
      return this.props.showMessage('Error, no se logró actualizar tu perfil')
    }
  }

  @autobind
  async comeBackDoc(loading, editando){
    console.log('Recibiendo estados: ', loading, editando)
    if((loading && editando) === false){
        setTimeout(window.location.href = localStorage.getItem('docLink'),2000) 
    }
  }

  @autobind
  async crearDiroLink(){
    console.log("crearDiroLink")
    try {
      let diroResponse = await this.props.getDiroLink()
      let link = diroResponse.getDiroLink
      console.log("Link", link)
      this.setState({
        diroReady: true,
        diroLink: link
      })
    } catch( error ){
      console.log("no pude obtener link diro", error)
    }
  }

  formarRut(data) {
    if (!data || data.length === 0) {
      this.setState({valid: true})
      this.setState({rut: data})
      return
    }
    if (data.length < 3) {
      this.setState({valid: false})
      this.setState({rut: data})
      return
    }
    var numbers = data.replace(/[^\dkK]/g, '')
    this.validate(numbers)
    var parts = numbers.split('')
    if (parts.length === 0) return numbers
    var last = parts.pop()
    if (parts.length === 0) return numbers
    var final = numeral(parts.join('')).format('0,0') + '-' + last
    final = final.replace(/,/g, '.')
    this.setState({rut: final})
  }
  
  validate(valor) {
    valor = valor.replace('-', '')
    let cuerpo = valor.slice(0, -1)
    let dv = valor.slice(-1).toUpperCase()
    if (cuerpo.length < 7) {
      return false
    }
    let suma = 0
    let multiplo = 2
    for (let i = 1; i <= cuerpo.length; i++) {
      let index = multiplo * valor.charAt(cuerpo.length - i)
      suma = suma + index
      if (multiplo < 7) {
        multiplo = multiplo + 1
      } else {
        multiplo = 2
      }
    }
    let dvEsperado = 11 - suma % 11
    dv = dv === 'K' ? 10 : dv
    dv = dv === '0' ? 11 : dv
    if (String(dvEsperado) !== String(dv)) {
      this.setState({valid: false})
      return false
    }
    this.setState({valid: true})
    return true
  }

  render() {
    if(!this.state.diroReady)
      this.crearDiroLink()
    return (
      <div className={styles.container}>
        <div className="section">
          {this.renderUserInfo()}
          {this.renderEditar()}
        </div>
      </div>
    )
  }

  renderRutError() {
    console.log("renderError")
    if(this.state.valid || ! this.state.rut || this.state.rut.trim() === "") return
    return <div className={styles.error}>Rut invalido</div>
  }

  editarInfo(){
    this.setState({ 
      name: this.props.profile.name,
      lastName: this.props.profile.lastName,
      phone: this.props.profile.phone,
      rut: this.props.profile.rut
    })
    this.setState({editando: !this.state.editando })
  }
  
  renderEditar(){
    if(this.state.editando)
    
      return (
        <div>
            <div className="content cols-sm-6">
              <Form state={this.state} onChange={changes => this.setState(changes)} >
              Nombres <Field
                fieldName="name"
                type={Text}
                fieldType="text"
                placeholder="Nombres"
              />
              Apellidos <Field
                fieldName="lastName" 
                type={Text}
                fieldType="text"
                placeholder="Apellidos"
              />
              Telefono <Field
                fieldName="phone"
                type={Text}
                fieldType="text"
                placeholder="Telefono"
              />
              Rut <Field
                fieldName="rut"
                type={Text}
                fieldType="text"
                placeholder="Rut"
                onChange={ event => this.formarRut(event) }
              />
              {this.renderRutError()}
            </Form>
              <br />
              <Button  className={styles.btnCancelar} primary onClick={() => this.editarInfo()}>
                Cancelar
              </Button>
              <Button disabled={!this.state.valid} loading={this.state.loading} primary onClick={() => this.validateAndSend()}>
                Guardar
              </Button>
            </div>
          </div>
      ) 

  }
  
  initDiro(){
    // Cambiar estado depayment a INIT
    window.location.href=this.state.diroLink
  }  

  renderUserInfo(){
    if(!this.state.editando){
      return (
        <div className="content">
          <p>Nombres: <b>{this.props.profile.name || "No informado" }</b></p>
          <p>Apellidos: <b>{this.props.profile.lastName || "No informado"}</b></p>
          <p>Telefono: <b>{this.props.profile.phone || "No informado"}</b></p>
          <p>Rut: <b>{this.props.profile.rut || "No informado"}</b></p>
          <Button primary onClick={() => this.editarInfo() }>
            Editar
          </Button>
          {this.renderBtnValidaUsuario()}
        </div>
      )
    }
  }

  renderBtnValidaUsuario(){
    /*
    if(this.state.diroReady){
      return(
          <Button primary onClick={() => this.initDiro() }>
            Validar Informacion de Usuario
          </Button>
      )
    }
    */
  }
}


// WEBPACK FOOTER //
// ./src/App/Pages/Settings/Profile/index.js